export const childSexFormTestId = "components/fragments/forms/child-sex-form/form";
export const childSexFormSelectSexTestId = "components/fragments/forms/child-sex-form/Select-sex";
export const childSexFormLabelTestId = "components/fragments/forms/child-sex-form/label";

export interface childSex {
  readonly sexCode: string;
  readonly label: string;
}

export const childSexes: childSex[] = [
  {
    label: "まだわからない / 回答しない",
    sexCode: "0",
  },
  {
    label: "女の子",
    sexCode: "2",
  },
  {
    label: "男の子",
    sexCode: "1",
  },
];
